import { render, staticRenderFns } from "./ServiceFavoriteStar.vue?vue&type=template&id=0d95237c"
import script from "./ServiceFavoriteStar.vue?vue&type=script&lang=js"
export * from "./ServiceFavoriteStar.vue?vue&type=script&lang=js"
import style0 from "./ServiceFavoriteStar.vue?vue&type=style&index=0&id=0d95237c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports